import {
  Avatar,
  Box,
  Container,
  Divider,
  Flex,
  Grid,
  Heading,
  Icon,
  Spinner,
  Text,
} from "@chakra-ui/react";
import { useQuery } from "react-query";
import { FiAward, FiBookOpen, FiCheckCircle } from "react-icons/fi";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { getUserProfile, getUserStats } from "../../../services/userApi";
import ReadingStreakCard from "../components/ReadingStreakCard";

const PublicProfile = () => {
  const { userHandle } = useParams();
  const [activityYear, setActivityYear] = useState(new Date().getFullYear());

  const { data, isLoading, isSuccess } = useQuery(
    ["user", userHandle],
    () => getUserProfile(userHandle),
    {
      onSuccess: (response, status) => {},
      enabled: !!userHandle,
    }
  );

  const statsQuery = useQuery(
    ["userStats", userHandle, activityYear],
    () => getUserStats(userHandle, activityYear),
    {
      onSuccess: (response, status) => {},
      enabled: !!userHandle,
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
    }
  );

  if (isLoading || !isSuccess) {
    return <Spinner />;
  }

  const user = data?.data;

  return (
    <Container maxW="container.lg" py={{ base: 4, md: 8 }}>
      <Box
        bg="gray.800"
        border="1px solid"
        borderColor="gray.700"
        borderRadius="xl"
        overflow="hidden"
      >
        <Flex
          align="center"
          gap={{ base: 4, md: 5 }}
          px={{ base: 5, md: 8 }}
          py={{ base: 5, md: 7 }}
        >
          <Avatar
            name={user.userHandle || `${user.firstName} ${user.lastName}`}
            size={{ base: "lg", md: "xl" }}
            src={user.profilePicture}
          />
          <Box flex="1" minW="0">
            <Heading as="h1" fontSize={{ base: "xl", md: "2xl" }}>
              {user.userHandle
                ? user.userHandle
                : `${user.firstName} ${user.lastName.charAt(0)}.`}
            </Heading>
            <Text color="gray.400" fontSize={{ base: "sm", md: "md" }}>
              Member since {user?.memberSince}
            </Text>
          </Box>
        </Flex>

        {statsQuery.isLoading && (
          <Flex justify="center" py="12">
            <Spinner />
          </Flex>
        )}
        {statsQuery.isSuccess && (
          <Grid
            borderTop="1px solid"
            borderColor="gray.700"
            templateColumns="repeat(3, 1fr)"
          >
            <PublicStat
              icon={FiCheckCircle}
              label="Reading orders completed"
              value={statsQuery?.data?.readingOrdersCompleted ?? 0}
            />
            <PublicStat
              borderLeft="1px solid"
              borderColor="gray.700"
              icon={FiBookOpen}
              label="Comics read to date"
              value={statsQuery?.data?.comicsRead ?? 0}
            />
            <PublicStat
              borderLeft="1px solid"
              borderColor="gray.700"
              icon={FiAward}
              label="Redwing ranking"
              value={statsQuery?.data?.redwingRank ?? "–"}
            />
          </Grid>
        )}
        {statsQuery.isSuccess && <Divider borderColor="gray.700" />}
        {statsQuery.isSuccess && (
          <ReadingStreakCard
            activity={statsQuery?.data?.readingActivity}
            isOwnProfile={false}
            longestStreak={statsQuery?.data?.longestReadingStreak}
            lastRead={statsQuery?.data?.lastRead}
            lastReadAt={statsQuery?.data?.lastReadAt}
            lastReadOrder={statsQuery?.data?.lastReadOrder}
            onYearChange={setActivityYear}
            streak={statsQuery?.data?.readingStreak}
          />
        )}

        {/* <Tabs mt="6" variant="solid-rounded">
        <TabList>
          <Tab>Activity</Tab>
          <Tab>Reading orders</Tab>
          <Tab>Stats</Tab>
          <Tab>Favourites</Tab>
        </TabList>

        <TabPanels>
          <TabPanel>
            <p>one!</p>
          </TabPanel>
          <TabPanel>
            <p>two!</p>
          </TabPanel>
          <TabPanel>
            <p>three!</p>
          </TabPanel>
        </TabPanels>
      </Tabs> */}
      </Box>
    </Container>
  );
};

const PublicStat = ({ icon, label, value, ...props }) => (
  <Box px={{ base: 2, md: 5 }} py={{ base: 5, md: 7 }} {...props}>
    <Flex align="center" gap="2">
      <Text
        fontSize={{ base: "2xl", md: "3xl" }}
        fontWeight="bold"
        lineHeight="1"
      >
        {value}
      </Text>
      <Icon as={icon} boxSize="4" color="red.300" />
    </Flex>
    <Text color="gray.400" fontSize={{ base: "xs", md: "sm" }} mt="2">
      {label}
    </Text>
  </Box>
);

export default PublicProfile;
